import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [scrolled, setScrolled] = useState(!isHome);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isHome) {
      setScrolled(true);
      return;
    }

    const handleScroll = () => {
      const threshold = window.innerHeight - 80;
      const isScrolled = window.scrollY > threshold;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    // Initial check
    handleScroll();

    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled, isHome]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isOpen ? 'open' : ''}`}>
      <div className="container navbar-container">
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src="/logo.webp" alt="Logo" className="navbar-icon" width="40" height="40" />
            aurora<span className="dot">.</span>code
          </Link>
        </div>
        
        <div className="navbar-center desktop-only">
          <Link to="/" className="nav-link" data-text="Home"><span>Home</span></Link>
          <Link to="/#services" className="nav-link" data-text="About Us"><span>About Us</span></Link>
          <Link to="/#projects" className="nav-link" data-text="Works"><span>Works</span></Link>
          <Link to="/plans" className="nav-link" data-text="Plans"><span>Plans</span></Link>
          <Link to="/#faq" className="nav-link" data-text="FAQ"><span>FAQ</span></Link>
        </div>

        <div className="navbar-right desktop-only">
          <Link to="/#contact" className="btn btn-sm">
            Contact Us
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor" d="M20 5.41L18.59 4L7 15.59V9H5v10h10v-2H8.41z"/>
            </svg>
          </Link>
        </div>

        <button className="mobile-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>

      <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>
        <div className="mobile-links">
          <Link to="/" className="mobile-link" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/#services" className="mobile-link" onClick={() => setIsOpen(false)}>About Us</Link>
          <Link to="/#projects" className="mobile-link" onClick={() => setIsOpen(false)}>Works</Link>
          <Link to="/plans" className="mobile-link" onClick={() => setIsOpen(false)}>Plans</Link>
          <Link to="/#faq" className="mobile-link" onClick={() => setIsOpen(false)}>FAQ</Link>
          <Link to="/#contact" className="btn btn-sm mobile-btn" onClick={() => setIsOpen(false)}>Contact Us</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
